import { useState } from "react";
import { COMPLETED_ORDER_STATUS } from "@constants";
import { IOrder } from "../interface/IOrder";
import { getOrderListRoute } from "@api-routes";
import { getResponseToState, IOrderListResponse } from "../mappers/getOrderListMapper";
import { useFetch } from "@common/hook/useFetch";

export const useOrderList = () => {
    const [orderList, setOrderList] = useState<IOrder[]>([]);
    const [getOrdersState, { get }] = useFetch();

    const getOrders = (startDateTime?: string) => {
        /* Default value that may be removed in the future */
        const orderParamsUrl = startDateTime
            ? `?startDateTime=${startDateTime}&status=COMPLETED`
            : "?startDateTime=2018-01-07T19:24:58.730Z";

        get<IOrderListResponse>(getOrderListRoute(orderParamsUrl)).then((orderListResponse) => {
            if (orderListResponse) {
                const mappedOrderList = getResponseToState(orderListResponse);

                const filteredOrders = startDateTime
                    ? mappedOrderList
                    : mappedOrderList.filter((order) => order.status !== COMPLETED_ORDER_STATUS);

                setOrderList(filteredOrders);
            }
        });
    };

    return { orderList, getOrdersState, getOrders };
};
